import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/app/layouts/default.vue").then(m => m.default || m)),
  simple: defineAsyncComponent(() => import("/app/app/layouts/simple.vue").then(m => m.default || m))
}